(function () {
"use strict";
var data = window.__BRAND__ || {};
var shop = data.shop || {};
var $ = function (sel, scope) { return (scope || document).querySelector(sel); };
var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
var finePointer = window.matchMedia && matchMedia("(pointer: fine)").matches;
function safe(fn, name) { try { fn(); } catch (e) { console.warn("[" + name + "] failed:", e); } }
function store(key, val) {
try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (_) { return null; }
}
function initShopLinks() {
if (!shop.domain) return;
var base = "https://" + shop.domain.replace(/^https?:\/\//, "").replace(/\/$/, "");
if (shop.variantId) $$("[data-buy]").forEach(function (a) { a.href = base + "/cart/" + shop.variantId + ":1"; });
if (shop.handle) $$("[data-product]").forEach(function (a) { a.href = base + "/products/" + shop.handle; });
$$("[data-store]").forEach(function (a) { a.href = base; });
if (shop.price) $$("[data-price]").forEach(function (el) { el.textContent = shop.price; });
}
function initHeaderHeight() {
var header = $("[data-nav]");
if (!header) return;
var set = function () { document.documentElement.style.setProperty("--header-h", header.offsetHeight + "px"); };
set(); window.addEventListener("resize", set, { passive: true });
}
function initNav() {
var header = $("[data-nav]"), bar = $("[data-progress]"), ticking = false;
function update() {
var y = window.scrollY || window.pageYOffset;
if (header) header.classList.toggle("is-solid", y > 30);
if (bar) {
var max = document.documentElement.scrollHeight - window.innerHeight;
bar.style.transform = "scaleX(" + (max > 0 ? Math.min(1, y / max) : 0).toFixed(4) + ")";
}
ticking = false;
}
window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
update();
}
function initBuyBar() {
var bar = $("[data-buybar]"), hero = $(".hero");
if (!bar || !hero || !("IntersectionObserver" in window)) return;
var visible = new Set(), heroVisible = true;
var sync = function () { bar.classList.toggle("is-shown", !heroVisible && visible.size === 0); };
new IntersectionObserver(function (es) { heroVisible = es[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(hero);
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
sync();
}, { threshold: 0.05 });
$$("main [data-buy]").forEach(function (a) { io.observe(a); });
}
function initStages() {
var tabs = $$("[data-stage]");
if (!tabs.length) return;
function activate(tab) {
tabs.forEach(function (t) {
var on = t === tab;
t.classList.toggle("is-active", on);
t.setAttribute("aria-selected", on ? "true" : "false");
t.tabIndex = on ? 0 : -1;
var panel = document.getElementById(t.getAttribute("data-stage"));
if (panel) panel.classList.toggle("is-active", on);
});
}
tabs.forEach(function (t, i) {
t.addEventListener("click", function () { activate(t); });
t.addEventListener("keydown", function (e) {
var dir = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
if (!dir) return;
var next = tabs[(i + dir + tabs.length) % tabs.length];
activate(next); next.focus();
});
});
activate(tabs[0]);
}
function initFlips() {
$$(".flip").forEach(function (b) {
b.addEventListener("click", function () {
var on = !b.classList.contains("is-flipped");
b.classList.toggle("is-flipped", on);
b.setAttribute("aria-pressed", on ? "true" : "false");
});
});
}
function initRail() {
var track = $("[data-rail-track]");
if (!track) return;
$$("[data-rail]").forEach(function (btn) {
btn.addEventListener("click", function () {
var card = track.querySelector(".topic");
var step = card ? card.getBoundingClientRect().width + 18 : 300;
track.scrollBy({ left: step * parseInt(btn.getAttribute("data-rail"), 10), behavior: "smooth" });
});
});
}
function initTilt() {
if (!finePointer) return;
$$("[data-tilt]").forEach(function (el) {
el.addEventListener("mousemove", function (e) {
var r = el.getBoundingClientRect();
var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
var k = Math.min(1, 420 / r.width);
el.style.setProperty("--ry", ((x - 0.5) * 14 * k).toFixed(2) + "deg");
el.style.setProperty("--rx", ((0.5 - y) * 10 * k).toFixed(2) + "deg");
el.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
el.style.setProperty("--my", (y * 100).toFixed(1) + "%");
});
el.addEventListener("mouseout", function (e) {
if (el.contains(e.relatedTarget)) return;
el.style.setProperty("--rx", "0deg"); el.style.setProperty("--ry", "0deg");
});
});
}
function initReveals() {
var items = $$(".reveal");
if (!("IntersectionObserver" in window)) { items.forEach(function (el) { el.classList.add("is-visible"); }); return; }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
});
}, { threshold: 0.05, rootMargin: "0px 0px -6% 0px" });
items.forEach(function (el) {
var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
el.style.transitionDelay = Math.min(idx, 6) * 70 + "ms";
io.observe(el);
});
setTimeout(function () { items.forEach(function (el) { el.classList.add("is-visible"); }); }, 6000);
}
function initFaq() {
var all = $$(".faq details");
all.forEach(function (d) {
d.addEventListener("toggle", function () { if (d.open) all.forEach(function (o) { if (o !== d) o.open = false; }); });
});
}
function initYear() { $$("[data-year]").forEach(function (el) { el.textContent = new Date().getFullYear(); }); }
function initMusic() {
var btn = $("[data-music]");
var label = $("[data-music-label]");
var AC = window.AudioContext || window.webkitAudioContext;
if (!btn || !AC) { if (btn) btn.style.display = "none"; return; }
var BEAT = 0.72;
var VOLUME = 0.16;
var N = { C4: 261.63, D4: 293.66, E4: 329.63, F4: 349.23, G4: 392.0, A4: 440.0, B4: 493.88,
C5: 523.25, D5: 587.33, E5: 659.25, F5: 698.46, G5: 783.99, A5: 880.0, B5: 987.77, C6: 1046.5,
C3: 130.81, F3: 174.61, G3: 196.0, E3: 164.81, A3: 220.0 };
var SONG = [
["C", [["E5", .5], ["E5", .5], ["G5", 2]]],
["C", [["E5", .5], ["E5", .5], ["G5", 2]]],
["C", [["E5", .5], ["G5", .5], ["C6", 1], ["B5", 1]]],
["F", [["A5", 1], ["A5", 1], ["G5", 1]]],
["G", [["D5", .5], ["E5", .5], ["F5", 1], ["D5", 1]]],
["G", [["D5", .5], ["E5", .5], ["F5", 2]]],
["G", [["D5", .5], ["F5", .5], ["B5", 1], ["A5", 1]]],
["C", [["G5", 1], ["B5", 1], ["C6", 1]]],
["C", [["C5", .5], ["C5", .5], ["C6", 2]]],
["F", [["A5", .5], ["F5", .5], ["G5", 2]]],
["C", [["E5", .5], ["C5", .5], ["F5", 1], ["G5", 1]]],
["G", [["A5", 1], ["G5", 2]]],
["C", [["C5", .5], ["C5", .5], ["C6", 2]]],
["F", [["A5", .5], ["F5", .5], ["G5", 2]]],
["G", [["E5", .5], ["C5", .5], ["F5", .5], ["E5", .5], ["D5", 1]]],
["C", [["C5", 3]]],
["C", []]
];
var CHORDS = { C: ["C3", "E3", "G3"], F: ["F3", "A3", "C4"], G: ["G3", "D4", "B4"] };
var ctx = null, master = null, wet = null, playing = false, timer = null;
var nextTime = 0, barIdx = 0;
function build() {
ctx = new AC();
master = ctx.createGain(); master.gain.value = 0;
var lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 3200;
master.connect(lp); lp.connect(ctx.destination);
wet = ctx.createGain(); wet.gain.value = 0.32;
var delay = ctx.createDelay(1.5); delay.delayTime.value = 0.38;
var fb = ctx.createGain(); fb.gain.value = 0.42;
var dlp = ctx.createBiquadFilter(); dlp.type = "lowpass"; dlp.frequency.value = 1800;
wet.connect(delay); delay.connect(dlp); dlp.connect(fb); fb.connect(delay); dlp.connect(master);
}
function bell(freq, t, dur) {
var g = ctx.createGain();
g.gain.setValueAtTime(0.0001, t);
g.gain.exponentialRampToValueAtTime(0.5, t + 0.008);
g.gain.exponentialRampToValueAtTime(0.0001, t + Math.max(1.6, dur * 2.2));
g.connect(master); g.connect(wet);
[[1, 1], [2.01, .32], [3.98, .12]].forEach(function (p) {
var o = ctx.createOscillator(), og = ctx.createGain();
o.type = "sine"; o.frequency.value = freq * p[0]; og.gain.value = p[1];
o.connect(og); og.connect(g); o.start(t); o.stop(t + Math.max(1.7, dur * 2.3));
});
}
function pad(names, t, dur) {
names.forEach(function (n) {
var o = ctx.createOscillator(), g = ctx.createGain();
o.type = "triangle"; o.frequency.value = N[n];
g.gain.setValueAtTime(0.0001, t);
g.gain.linearRampToValueAtTime(0.045, t + dur * 0.35);
g.gain.linearRampToValueAtTime(0.0001, t + dur * 1.05);
o.connect(g); g.connect(master); o.start(t); o.stop(t + dur * 1.1);
});
}
function scheduler() {
while (nextTime < ctx.currentTime + 1.2) {
var bar = SONG[barIdx], t = nextTime;
pad(CHORDS[bar[0]], t, 3 * BEAT);
bar[1].forEach(function (note) { bell(N[note[0]], t, note[1] * BEAT); t += note[1] * BEAT; });
nextTime += 3 * BEAT;
barIdx = (barIdx + 1) % SONG.length;
}
}
function setUI() {
btn.classList.toggle("is-playing", playing);
btn.setAttribute("aria-pressed", playing ? "true" : "false");
btn.setAttribute("aria-label", playing ? "Pausar música de fondo" : "Activar música de fondo");
if (label) label.textContent = playing ? "Nana sonando" : "Activar nana";
}
function play() {
if (playing) return;
if (!ctx) build();
if (ctx.state === "suspended") ctx.resume();
playing = true;
nextTime = ctx.currentTime + 0.15;
master.gain.cancelScheduledValues(ctx.currentTime);
master.gain.setValueAtTime(master.gain.value, ctx.currentTime);
master.gain.linearRampToValueAtTime(VOLUME, ctx.currentTime + 2.5);
scheduler(); timer = setInterval(scheduler, 250);
setUI();
}
function stop() {
if (!playing) return;
playing = false;
clearInterval(timer);
master.gain.cancelScheduledValues(ctx.currentTime);
master.gain.setValueAtTime(master.gain.value, ctx.currentTime);
master.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.8);
setTimeout(function () { if (!playing && ctx) ctx.suspend(); }, 900);
setUI();
}
btn.addEventListener("click", function (e) {
e.stopPropagation();
if (playing) { stop(); store("bf-music", "off"); } else { play(); store("bf-music", "on"); }
});
var GESTURES = ["pointerdown", "pointerup", "mousedown", "touchend", "keydown", "click"];
var waiting = false;
function onGesture(e) {
if (!waiting) return;
if (btn.contains(e.target)) { stopWaiting(); return; }
stopWaiting();
play();
}
function stopWaiting() {
waiting = false;
GESTURES.forEach(function (g) { document.removeEventListener(g, onGesture, true); });
}
function waitForGesture() {
if (waiting || playing) return;
waiting = true;
GESTURES.forEach(function (g) { document.addEventListener(g, onGesture, true); });
}
function tryAutoplay() {
if (store("bf-music") === "off") return;
try {
if (!ctx) build();
var p = ctx.resume();
var check = function () {
if (ctx.state === "running") { stopWaiting(); play(); }
else waitForGesture();
};
if (p && p.then) { p.then(check, waitForGesture); setTimeout(check, 400); }
else check();
} catch (_) { waitForGesture(); }
}
waitForGesture();
tryAutoplay();
document.addEventListener("visibilitychange", function () {
if (!ctx) return;
if (document.hidden && playing) ctx.suspend();
else if (!document.hidden && playing) ctx.resume();
});
setUI();
}
function boot() {
safe(initShopLinks, "initShopLinks");
safe(initHeaderHeight, "initHeaderHeight");
safe(initNav, "initNav");
safe(initBuyBar, "initBuyBar");
safe(initStages, "initStages");
safe(initFlips, "initFlips");
safe(initRail, "initRail");
safe(initTilt, "initTilt");
safe(initReveals, "initReveals");
safe(initFaq, "initFaq");
safe(initYear, "initYear");
safe(initMusic, "initMusic");
document.documentElement.classList.add("is-ready");
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
else boot();
})();